module.exports = __webpack_public_path__ + "static/media/fb.faf0bbbe.png";